import { InputValidatorMessages } from '../constants/ErrorMessages';
import moment from 'moment';

export const emailValidator = (email: string): string => {
  const validEmail = new RegExp(/^[A-Za-z0-9_!#$%&'*+\\/=?`{|}~^.-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,}$/, 'gm');

  if (!email || email.length <= 0) {
    return InputValidatorMessages.emailEmpty;
  }
  if (!validEmail.test(email.trim())) {
    return InputValidatorMessages.emailNotValid;
  }

  return '';
};

export const publicEmailValidator = (email: string): string => {
  const validEmail = new RegExp(/^[A-Za-z0-9_!#$%&'*+\\/=?`{|}~^.-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,}$/, 'gm');

  if (!email || email.length <= 0) {
    return InputValidatorMessages.publicEmailEmpty;
  }
  if (!validEmail.test(email.trim())) {
    return InputValidatorMessages.publicEmailNotValid;
  }

  return '';
};

export const passwordValidator = (password: string): string => {
  if (!password || password.length <= 0) {
    return InputValidatorMessages.passwordEmpty;
  }
  if (password.length < 8) {
    return InputValidatorMessages.passwordLength;
  }
  // Check Minimum password requirements:
  // - 1 lowercase character
  // - 1 uppercase character
  // - 1 digit (0-9)
  if (!(/[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password))) {
    return InputValidatorMessages.passwordValidity;
  }

  return '';
};

export const stringValidator = (name: string, value: string): string => {
  if (!value || value.length <= 0) {
    return name + InputValidatorMessages.stringEmpty;
  }

  return '';
};

export const heightValidator = (value: string): string => {
  if (!value || value.length <= 0) {
    return InputValidatorMessages.heightIsEmpty;
  } else if (Number.isNaN(Number(value)) || Number(value) < 50 || Number(value) > 255) {
    return InputValidatorMessages.invalidHeight;
  }

  return '';
};

export const weightValidator = (value: string): string => {
  if (!value || value.length <= 0) {
    return InputValidatorMessages.weightIsEmpty;
  } else if (Number.isNaN(Number(value)) || Number(value) < 25 || Number(value) > 300) {
    return InputValidatorMessages.invalidWeight;
  }

  return '';
};

export const genderTypeValidator = (gender: string): string => {
  if (!gender || gender.length <= 0 || (gender !== 'male' && gender !== 'female')) {
    return InputValidatorMessages.genderEmpty;
  }

  return '';
};

export const dateValidator = (format: string, value: string): string => {
  if (!value || value.length <= 0) {
    return InputValidatorMessages.dobEmpty;
  }

  if (!moment(value, format, true).isValid()) {
    return InputValidatorMessages.dobValidity;
  }

  const years = moment().diff(value, 'years', true);
  if (years < 18) {
    return InputValidatorMessages.dobUnderAge;
  }

  return '';
};

export const authCodeValidator = (value: string): string => {
  if (!value || value.length <= 0) {
    return InputValidatorMessages.authCodeEmpty;
  }

  return '';
};

export const nameValidator = (name: string): string => {
  if (!name || name.length <= 0) {
    return InputValidatorMessages.nameIsEmpty;
  }

  return '';
};

export const isNumeric = (value: string): boolean => {
  return value.trim().length > 0 && !isNaN(Number(value));
};

export const AgeValidator = (age: string): string => {
  if (age.length == 0) {
    return InputValidatorMessages.ageIsEmpty;
  }
  if (isNaN(Number(age)) || Number(age) < 13 || Number(age) > 120) {
    return InputValidatorMessages.invalidAge;
  }
  return '';
};
